module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "pricing-table section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 fadeInLeftBig animated"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticClass: "row-p"
  }, [_vm._v(_vm._s(_vm.soluConents))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row fadeInRightBig animated"
  }, _vm._l((_vm.solutionsList), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "single-table text-center mb-4 mb-md-0"
    }, [_c('div', {
      staticClass: "table-top"
    }, [_c('h3', [_vm._v(_vm._s(v.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "30px"
      }
    }, [_vm._v("\n              " + _vm._s(v.description) + "\n            ")])])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cbbf218"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Solutions.vue
// module id = 31
// module chunks = 0